function AboutSection({ data }) {
  const aboutData = data || {};

  return (
    <div>
      <section className="about-section bg-secondary">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-12 col-lg-6">
              <div className="about-thumbnail">
                <div className="row g-4 align-items-end">
                  <div className="col-12 col-sm-6">
                    <img
                      src={aboutData.image_left || "assets/img/bg-img/3.jpg"}
                      alt=""
                      className="wow fadeInUp w-100"
                      data-wow-duration="1000ms"
                      data-wow-delay="600ms"
                      onError={(e) => {
                        e.target.src = "assets/img/bg-img/3.jpg";
                      }}
                    />
                    <div
                      className="experience-card mt-4 wow fadeInUp"
                      data-wow-duration="1000ms"
                      data-wow-delay="800ms"
                    >
                      <h2>
                        <span className="counter">{aboutData.experience_years || 20}</span>
                        <span>+</span>
                      </h2>
                      <p className="mb-0">Տարվա փորձ</p>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6">
                    <img
                      src={aboutData.image_right || "assets/img/bg-img/4.jpg"}
                      alt=""
                      className="wow fadeInUp w-100"
                      data-wow-duration="1000ms"
                      data-wow-delay="1000ms"
                      onError={(e) => {
                        e.target.src = "assets/img/bg-img/4.jpg";
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="about-content ps-md-4">
                <div className="section-heading">
                  <div className="sub-title">
                    <img src="assets/img/core-img/hammer.png" alt="" />
                    Մեր մասին
                  </div>
                  <h2 className="mb-4">
                    {aboutData.about_title}
                  </h2>
                  <p className="mb-5">
                    {aboutData.about_description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default AboutSection;
